"use client"

import { useState, useEffect } from "react"
import { useRouter } from '@/platform/navigation'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { LogOut, ShieldAlert } from "lucide-react"

export function SessionRevokedModal() {
  const router = useRouter()
  const [isOpen, setIsOpen] = useState(false)
  const [message, setMessage] = useState<string>("Your session was revoked by an administrator.")

  useEffect(() => {
    const handleRevoked = (event: Event) => {
      const customEvent = event as CustomEvent<{ message?: string }>
      if (customEvent.detail?.message) {
        setMessage(customEvent.detail.message)
      }
      setIsOpen(true)
    }

    window.addEventListener("session:revoked", handleRevoked)
    return () => window.removeEventListener("session:revoked", handleRevoked)
  }, [])

  const handleRedirectLogin = () => {
    setIsOpen(false)
    if (typeof window !== "undefined") {
      window.location.href = "/login"
    } else {
      router.push("/login")
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent showCloseButton={false} className="sm:max-w-md">
        <DialogHeader className="gap-2">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-destructive/15 text-destructive dark:bg-destructive/25">
            <ShieldAlert className="h-6 w-6" />
          </div>
          <DialogTitle className="text-center text-lg font-bold text-destructive">
            Session Revoked by Admin
          </DialogTitle>
          <DialogDescription className="text-center text-muted-foreground text-sm">
            {message} Please sign in again with your credentials to continue.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="mt-2">
          <Button
            type="button"
            onClick={handleRedirectLogin}
            className="w-full bg-destructive hover:bg-destructive/90 text-destructive-foreground font-bold gap-2"
          >
            <LogOut className="h-4 w-4" />
            Log In Again
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
